const Theme = {
  logo_image_url: 'bourgdepabos.png',

  text_font: `'Nunito', sans-serif`,
  text_color: 'black',

  button_color: 'black',
  button_outlined_as_default: true,

  photobooth_button_color: 'white',
  photobooth_button_text_color: 'black',
}

export default Theme
